// Authentication service for onboarding APIs

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.sortmyspot.com/';

export const onboardingSignup = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/web/user/onboarding-signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Signup failed');
    }

    // Store token in localStorage
    if (data.data && data.data.token) {
      localStorage.setItem('authToken', data.data.token);
      localStorage.setItem('user', JSON.stringify(data.data.record));

      // Trigger custom event to notify other components
      window.dispatchEvent(new Event('authChange'));
    }

    return data;
  } catch (error) {
    console.error('Signup error:', error);
    throw error;
  }
};

export const onboardingLogin = async (credentials) => {
  try {
    const response = await fetch(`${API_BASE_URL}/web/user/onboarding-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Login failed');
    }

    // Store token in localStorage
    if (data.data && data.data.token) {
      localStorage.setItem('authToken', data.data.token);
      localStorage.setItem('user', JSON.stringify(data.data.record));

      // Trigger custom event to notify other components
      window.dispatchEvent(new Event('authChange'));
    }

    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const updateOnboardingStatus = async (userId, statusData) => {
  try {
    const token = localStorage.getItem('authToken');

    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_BASE_URL}/web/user/update-onboarding-status`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        userId,
        ...statusData,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Status update failed');
    }

    // Update user in localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (statusData.onboarding_status !== undefined) {
      user.onboarding_status = statusData.onboarding_status;
    }
    if (statusData.admin_status !== undefined) {
      user.admin_status = statusData.admin_status;
    }
    localStorage.setItem('user', JSON.stringify(user));

    return data;
  } catch (error) {
    console.error('Update status error:', error);
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');

  // Trigger custom event to notify other components
  window.dispatchEvent(new Event('authChange'));
};

export const getStoredUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};
